import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["target", "label", "reason", "before", "after", "file", "placeholder", "submit"]

  disconnect() { this.releasePreview() }

  selectEvidence(event) {
    const button = event.relatedTarget
    if (!button) return
    this.targetTarget.value = button.dataset.evidenceKey
    this.labelTarget.textContent = button.dataset.evidenceLabel
    this.beforeTarget.src = button.dataset.previewUrl
    this.reasonTarget.value = ""
    this.fileTarget.value = ""
    this.preview()
    this.submitTarget.disabled = false
    this.submitTarget.value = "Salvar substituição"
  }

  preview() {
    this.releasePreview()
    this.afterTarget.hidden = true
    this.placeholderTarget.hidden = false
    this.fileTarget.setCustomValidity("")
    const file = this.fileTarget.files[0]
    if (!file) return
    const valid = ["image/jpeg", "image/png", "image/webp"].includes(file.type) && file.size > 0 && file.size <= 10 * 1024 * 1024
    this.fileTarget.setCustomValidity(valid ? "" : "Selecione uma imagem JPEG, PNG ou WebP de até 10 MB.")
    if (!valid) { this.fileTarget.reportValidity(); return }
    this.previewUrl = URL.createObjectURL(file)
    this.afterTarget.onload = () => this.fileTarget.setCustomValidity("")
    this.afterTarget.onerror = () => this.fileTarget.setCustomValidity("Não foi possível abrir esta imagem. Escolha outro arquivo.")
    this.afterTarget.src = this.previewUrl
    this.afterTarget.hidden = false
    this.placeholderTarget.hidden = true
  }

  save(event) {
    if (this.submitTarget.disabled) {
      event.preventDefault()
      return
    }
    this.submitTarget.disabled = true
    this.submitTarget.value = "Salvando…"
  }

  releasePreview() {
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl)
    this.previewUrl = null
  }
}
